import { feature, useFeature } from '@/app/context';
import type { SnapshotFrom } from 'xstate';
import type { approvalMachine } from './approval.machine';

export const useApprovalRef = () => feature('approval');
export const useApproval = <R>(selector: (snapshot: SnapshotFrom<typeof approvalMachine>) => R) =>
  useFeature('approval', selector);
export const useApprovalActions = () => {
  const ref = useApprovalRef();
  return { record: (filingId: string) => ref.send({ type: 'approval.record', filingId }) };
};
